import {React,useEffect} from "react";
import { Helmet } from "react-helmet";
import Transitions from "./Transitions";
import {SectionHeader} from "./Header";
import Headshot from "../img/headshot_BW.png";

function About() {

  // useEffect(() => {
  //   document.title = "ETCHNG | About";  
  
  // }, []);  

  return (
    <>

<Helmet>
        <title>ETCHNG | About</title>
        <meta name="description" content="About Eric Chung"/> 
        <meta name="keywords" content=" ETCHNG, medical illustrator"
        />
    </Helmet>
      <Transitions>
        <div className="wrapper">
          <div className="wrapper__inner">
            <SectionHeader
              smallText="Learn more"
              largeText="ABOUT ME"
              textColour="#f55a59"
            ></SectionHeader>
            <div className="work">
              <div className="twoColumn work__info">
                <h3>Hello there!</h3>
                <br />
                <p>
                  I'm Eric, a medical illustrator, animator, UX designer, and design technologist (not in any particular order)
                  specializing in the science and health fields. I have an
                  undergraduate background in human biology and kinesiology, as
                  well as a{" "}
                  <a href="https://bmc.med.utoronto.ca/" target="_blank">
                    Master of Science in Biomedical Communications
                  </a>
                  , specializing in interactive media design.
                </p>
                <p>
                  In addition to doing science coursework, such as human cadaver
                  dissections and pathology, I've worked with stakeholders
                  ranging from clinical educators, researchers and surgeons, to
                  the lay public, to create a number of interesting products and
                  visuals.
                </p>
                <p>
                  While I have a fairly extensive 3D background (started in
                  2012!), I look forward to all projects that have a good
                  balance of technical and conceptual problem-solving. I strive
                  to uncover relevant ways by which emerging technologies can be
                  applied in new use cases, and love prototyping applications
                  with Unity & WebGL, and front-end web tech stacks.
                </p>
                <p>
                  I currently work as a UX designer at Red Nucleus (formerly
                  INVIVO), an award-winning interactive agency that provides
                  innovative digital solutions exclusively to the global
                  pharmaceutical and medical device industries.
                </p>
                <p>
                  Curious about how I coded my site? It's an exercise in React,
                  Three.JS, and GLSL shaders (with some custom 3D modeling) — I
                  love creative coding!
                </p>
                <br />
                <p>
                  Check out my{" "}
                  <a
                    href="https://www.linkedin.com/in/eric-chung-456ab38a/"
                    target="_blank"
                  >
                    LinkedIn{" "}
                  </a>
                  for a closer look at my experience.
                </p>
              </div>


              <div className="twoColumn work__info">
                <img src={Headshot} alt="Eric Chung" />
                    </div>
            </div>
          </div>
        </div>
      </Transitions>
    </>
  );
}

export default About;
